/**
 * 내비게이션 표시 (시안 03 README 5.2·5.13, 7.1).
 *
 * - unreadChats: 안 읽은 1:1 멤버 말 합계(☰ 배지). 대화 목록(GET /api/chats)에서 셉니다
 * - roomDot: 별채대화 탭 점 = 안 본 '내 얘기'(여운 · 늦게 온 멤버 · 내 호칭이 든 말 · 부르기 · 고민 답 도착, C-20b).
 *   ☰ 목록을 받을 때 서버가 같이 알려 줍니다(별채를 보는 중이면 빼고)
 * - noticeDot: 상회칠판 탭 점 = 오늘 아직 안 본 매일 콘텐츠
 * 서버에 따로 묻지 않고, 화면이 받은 데이터로 고칩니다.
 */
import { create } from 'zustand';
import { fetchChats } from '../api/chat.js';

const NOTICE_SEEN_KEY = 'insaeng-notice-seen';

function readNoticeSeen() {
    try {
        return localStorage.getItem(NOTICE_SEEN_KEY);
    } catch {
        return null;
    }
}

export const useNav = create((set) => ({
    chats: [],
    unreadChats: 0,
    roomDot: false,
    inRoom: false,
    noticeDot: false,
    // 대화 선택 패널의 별채대화 줄에 보일 마지막 말(「오름: …」)
    roomPreview: '',

    async refreshChats(signal) {
        try {
            const { chats, roomDot } = await fetchChats({ signal });
            set((state) => ({
                chats,
                unreadChats: chats.reduce((sum, chat) => sum + (chat.unread ?? 0), 0),
                // 별채대화를 보는 중이면 점을 켜지 않습니다(그 화면이 직접 고침)
                ...(typeof roomDot === 'boolean' && !state.inRoom ? { roomDot } : {}),
            }));
        } catch {
            // 배지는 보조 표시입니다. 실패해도 화면을 막지 않습니다
        }
    },

    setRoomPreview(roomPreview) {
        set({ roomPreview });
    },

    setRoomDot(roomDot) {
        set({ roomDot });
    },

    setInRoom(inRoom) {
        set({ inRoom });
    },

    /** 오늘(서울) 매일 콘텐츠가 있는데 상회칠판을 아직 안 열었으면 점 */
    noteDailyToday(today, hasItemsToday) {
        set({ noticeDot: Boolean(hasItemsToday) && readNoticeSeen() !== today });
    },

    markNoticeSeen(today) {
        try {
            localStorage.setItem(NOTICE_SEEN_KEY, today);
        } catch {
            // 저장하지 못하면 다음에 점이 다시 보일 뿐입니다
        }
        set({ noticeDot: false });
    },
}));
